export const TRIGGER_RHUMB_SUCCESS = 'TRIGGER_RHUMB_SUCCESS';
export const TRIGGER_RHUMB_PARTIAL_SUCCESS = 'TRIGGER_RHUMB_PARTIAL_SUCCESS';
export const TRIGGER_RHUMB_FAILURE = 'TRIGGER_RHUMB_FAILURE';